export const videoMimetypes = {
	mp4: 'video/mp4',
	webm: 'video/webm',
	ogv: 'video/ogg',
	mov: null, // 'video/quicktime' (not supported by all browsers)
	avi: 'video/x-msvideo',
	wmv: 'video/x-ms-wmv',
	flv: 'video/x-flv',
	mkv: 'video/x-matroska',
	mpeg: 'video/mpeg',
	mpg: 'video/mpeg',
	m4v: 'video/x-m4v',
};

export const getMimetypeFromFilename = (filename: string | undefined): string | null => {
	const videoAttachmentFilepath = filename || '';
	const cleanedFilepath = videoAttachmentFilepath.replace(/\?.*$/, ''); // Remove query parameters
	const videoAttachmentFilename = cleanedFilepath.replace(/.*\//, ''); // Extract filename from path
	const videoAttachmentFiletype = videoAttachmentFilename.replace(/.*\./, '').toLowerCase(); // Extract file extension and normalize to lowercase
	const videoAttachmentMimetype = videoMimetypes[videoAttachmentFiletype as keyof typeof videoMimetypes];
	return videoAttachmentMimetype || null;
};

export const isVideoFile = (src?: string): boolean => {
	const mimetype = getMimetypeFromFilename(src || '');
	return !!mimetype;
};
